export default {
    /**
     * @description 配置显示在浏览器标签的title
     */
    title: '诺思技术',
    /** 公司名称 */
    name: '武汉诺思技术有限公司',
    /** 公司微信 */
    wechat: 'wangyigang2020',
    /** 公司邮箱 */
    email: '704429524@qq.com',
    /** 公司手机 */
    phone: '18986633323',
    /** 公司电话 */
    tel: '-',
    /** 公司地址 */
    address: '武汉东湖新技术开发区关东科技工业园华光大道18号高科大厦5楼50808',
    /** 备案号 */
    keepOnRecordIcp: '鄂ICP备2022010899号',
    /** 百度地图相关信息 */
    BDMapInfo: {
        longitude: 114.437191,
        latitude: 30.511032,
        title: '高科大厦',
        address: '武汉东湖新技术开发区关东科技工业园华光大道18号高科大厦5楼50808'
    }
}


// WEBPACK FOOTER //
// ./src/config/index.js